import React, { useState } from 'react'

export default function AccountWishlist() {

    return (
    <p>Account Wishlist</p>
    );
}